import {
  alertCx,
  alertStatus
} from "./chunk-A2GPBZF4.mjs";
import {
  AlertProvider
} from "./chunk-Z4HKIJIY.mjs";

// src/Alert.tsx
import { forwardRef, julo, cx } from "@julo-ui/system";
import { jsx } from "react/jsx-runtime";
var Alert = forwardRef((props, ref) => {
  const { children, className, status = "neutrals", sx, ...resProps } = props;
  return /* @__PURE__ */ jsx(AlertProvider, { value: { status }, children: /* @__PURE__ */ jsx(
    julo.div,
    {
      ref,
      className: cx("julo-alert", className),
      "data-alert-status": status,
      sx: {
        ...alertStatus[status],
        ...sx
      },
      ...resProps,
      __css: alertCx,
      children
    }
  ) });
});
Alert.displayName = "Alert";
var Alert_default = Alert;

export {
  Alert_default
};
